import { plural } from "@lingui/macro";
import React, { useEffect, useMemo, useRef, useState } from "react";

import {
  Text,
  WhooshTextProps,
  HStack,
} from "@whoosh/design-system/src/components/primitive";

export type VariableStringListDisplay = "list" | "select";
export type VariableStringListProps = {
  items: string[];
  display?: VariableStringListDisplay;
  textProps?: WhooshTextProps;
};
export const VariableStringList = ({
  items,
  display = "list",
  textProps,
}: VariableStringListProps) => {
  const ref = useRef<any>(null);

  const [itemsToDisplay, setItemsToDisplay] = useState(items.length);
  const [overWidth, setOverWidth] = useState(false);

  useEffect(() => {
    if (items && items.length) {
      setItemsToDisplay(items.length);
    }
    setOverWidth(false);
  }, [items, setItemsToDisplay]);

  useEffect(() => {
    if (ref?.current && ref.current?.parentElement) {
      const elemWidth = ref.current.offsetWidth + 20;
      const parentWidth = ref.current.parentElement.offsetWidth;

      if (elemWidth >= parentWidth && parentWidth > 0) {
        setOverWidth(true);
        setItemsToDisplay((prev) => (prev > 1 ? prev - 1 : prev));
      }
    }
  }, [ref, itemsToDisplay, setOverWidth, display]);

  const listDisplayValue =
    items.slice(0, itemsToDisplay).reduce((acc, cur, i) => {
      return `${acc} ${cur}${i + 1 < itemsToDisplay ? ", " : ""}`;
    }, "") +
    (itemsToDisplay < items.length ? ` +${items.length - itemsToDisplay}` : "");

  const selectDisplayValue = useMemo(
    () =>
      !overWidth
        ? items.reduce((acc, cur, i) => {
            return `${acc} ${cur}${i + 1 < itemsToDisplay ? ", " : ""}`;
          }, "")
        : plural(items.length, {
            one: "# selected",
            other: "# selected",
          }),
    [items, itemsToDisplay, overWidth]
  );

  const displayValue =
    display === "list" ? listDisplayValue : selectDisplayValue;

  return (
    <HStack width="100%">
      <Text
        maxFontSizeMultiplier={2}
        ref={ref}
        width="auto"
        fontFamily="Inter_400Regular"
        fontSize={12}
        lineHeight={20}
        letterSpacing={0}
        {...textProps}
      >
        {displayValue}
      </Text>
    </HStack>
  );
};
